import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
} from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject } from 'rxjs';
import { TimeOfDaySale } from '../../../../model/time-of-day-sale';
import { ISalesByTimeOfDayApiService } from './sales-by-time-of-day-api.interface';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { ExportSalesByTimeOfDayQueryDto } from './dtos/export-sales-by-time-of-day.query.dto';
import { FindSalesByTimeOfDayQueryDto } from './dtos/find-sales-by-time-of-day.query.dto';
import { FindSalesByTimeOfDayResponseDto } from './dtos/find-sales-by-time-of-day.response.dto';

@Injectable({
  providedIn: 'root',
})
export class SalesByTimeOfDayMockApiService implements ISalesByTimeOfDayApiService {
  data = {
    time_of_day_sales: {
      items: [] as TimeOfDaySale[],
      queryOptions: {
        page: 1,
        size: 10,
      } as QueryOptions<TimeOfDaySale>,
      subject: new BehaviorSubject<Maybe<TimeOfDaySale[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get timeOfDaySalesData() {
    return this.data['time_of_day_sales'] as Data<
      TimeOfDaySale,
      TimeOfDaySale
    >;
  }

  findSalesByTimeOfDay(query: FindSalesByTimeOfDayQueryDto): Promise<FindSalesByTimeOfDayResponseDto> {
    throw new Error('Method not implemented.');
  }
  exportSalesByTimeOfDay(query: ExportSalesByTimeOfDayQueryDto, options?: HandleBlobHttpResponseOptions): void {
    throw new Error('Method not implemented.');
  }
}
